<template>
  <div class="trace-resume w-100">
    <h1 class="mb-5">
      <span class="plot-name"> {{ plot.name }}</span>
    </h1>

    <pre-emergence-data v-if="plot.preEmergence" :plot="plot" :show-title="false"> </pre-emergence-data>

    <observation-table v-if="hasComments(plot.preEmergence)" :comments="plot.preEmergence.comments" />

    <hr v-if="plot.preEmergence" />

    <emergence-data v-if="plot.emergence" :plot="plot" :show-title="false" class="mt-3"> </emergence-data>

    <observation-table v-if="hasComments(plot.emergence)" :comments="plot.emergence.comments" />

    <hr v-if="plot.emergence" />

    <harvest-data v-if="plot.harvest" :plot="plot" :show-title="false" class="mt-3"> </harvest-data>

    <observation-table v-if="hasComments(plot.harvest)" :comments="plot.harvest.comments" />

    <hr v-if="plot.harvest" />

    <div v-if="hasPictures(plot.preEmergence) || hasPictures(plot.emergence) || hasPictures(plot.harvest)" class="mt-3">
      <h3 class="mb-4">Imágenes</h3>

      <div v-if="hasPictures(plot.preEmergence)">
        <h5 class="m-2">Pre Emergencia</h5>

        <plot-images-list :pictures="plot.preEmergence.pictures" @open-gallery="openGallery" />
      </div>

      <div v-if="hasPictures(plot.emergence)">
        <h5 class="m-2">Emergencia</h5>

        <plot-images-list :pictures="plot.emergence.pictures" @open-gallery="openGallery" />
      </div>

      <div v-if="hasPictures(plot.harvest)">
        <h5 class="m-2">Producción</h5>

        <plot-images-list :pictures="plot.harvest.pictures" @open-gallery="openGallery" />
      </div>
    </div>
    <div v-else>Sin imágenes</div>

    <vue-easy-lightbox :imgs="images" :index="index" :visible="visible" @hide="handleHide" />
  </div>
</template>

<script>
import PreEmergenceData from '@/views/Plots/Show/PreEmergenceData';
import EmergenceData from '@/views/Plots/Show/EmergenceData';
import HarvestData from '@/views/Plots/Show/HarvestData';
import PlotImagesList from '@/views/Plots/List/PlotImagesList';
import VueEasyLightbox from 'vue-easy-lightbox';
import ObservationTable from '../List/ObservationTable';

export default {
  components: {
    PreEmergenceData,
    EmergenceData,
    HarvestData,
    PlotImagesList,
    VueEasyLightbox,
    ObservationTable,
  },

  props: {
    plot: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      pictures: [],
      images: [],
      index: 0,
      visible: false,
    };
  },

  computed: {
    hasPictures() {
      return (picturable) => {
        return picturable && picturable.pictures.length > 0;
      };
    },

    hasComments() {
      return (commentable) => {
        return commentable && commentable.comments.length > 0;
      };
    },
  },

  created() {
    let keys = ['preEmergence', 'emergence', 'harvest'];
    keys.forEach((key) => {
      if (this.plot[key] && this.plot[key].pictures.length > 0) {
        this.pictures = [...this.pictures, ...this.plot[key].pictures];
      }
    });
  },

  methods: {
    openGallery(pictureId) {
      this.images = this.pictures.map((i) => i.url);
      this.index = this.pictures.findIndex((p) => p.id === pictureId);
      this.visible = true;

      if (!this.$sidebar.isMinimized) {
        this.$sidebar.toggleMinimize();
      }
    },

    handleHide() {
      this.visible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.plot-name {
  color: #ffffff;
}

::v-deep .vel-img-modal.vel-modal {
  left: 62px;
}

::v-deep .observations {
  .el-table tr,
  .el-table th {
    background-color: #0000005c !important;
    color: #ffffff;
  }

  .el-table td {
    color: #ffffff;
  }
}
</style>
